import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

interface IProps {
  id: string;
}

export const WWEchoImage: React.FC<IProps> = ({ id }) => {
  return (
    <>
      {id === '6000098' && (
        <StaticImage
          src="../../../images/ww/monsters/6000098.webp"
          alt="Echo"
        />
      )}
      {id === '6000099' && (
        <StaticImage
          src="../../../images/ww/monsters/6000099.webp"
          alt="Echo"
        />
      )}
      {id === '6000100' && (
        <StaticImage
          src="../../../images/ww/monsters/6000100.webp"
          alt="Echo"
        />
      )}
      {id === '6000101' && (
        <StaticImage
          src="../../../images/ww/monsters/6000101.webp"
          alt="Echo"
        />
      )}
      {id === '6000102' && (
        <StaticImage
          src="../../../images/ww/monsters/6000102.webp"
          alt="Echo"
        />
      )}
      {id === '6000103' && (
        <StaticImage
          src="../../../images/ww/monsters/6000103.webp"
          alt="Echo"
        />
      )}
      {id === '6000104' && (
        <StaticImage
          src="../../../images/ww/monsters/6000104.webp"
          alt="Echo"
        />
      )}
      {id === '6000105' && (
        <StaticImage
          src="../../../images/ww/monsters/6000105.webp"
          alt="Echo"
        />
      )}
      {id === '6000106' && (
        <StaticImage
          src="../../../images/ww/monsters/6000106.webp"
          alt="Echo"
        />
      )}
      {id === '6000093' && (
        <StaticImage
          src="../../../images/ww/monsters/6000093.webp"
          alt="Golden Junrock"
        />
      )}
      {id === '6000094' && (
        <StaticImage
          src="../../../images/ww/monsters/6000094.webp"
          alt="Calcified Junrock"
        />
      )}
      {id === '6000095' && (
        <StaticImage
          src="../../../images/ww/monsters/6000095.webp"
          alt="Aero Prism"
        />
      )}
      {id === '6000096' && (
        <StaticImage
          src="../../../images/ww/monsters/6000096.webp"
          alt="Rage Against the Statue"
        />
      )}
      {id === '6000097' && (
        <StaticImage
          src="../../../images/ww/monsters/6000097.webp"
          alt="Hurriclaw"
        />
      )}
      {id === '310000370' && (
        <StaticImage
          src="../../../images/ww/monsters/310000370.webp"
          alt="Galescourge Stalker"
        />
      )}
      {id === '310000380' && (
        <StaticImage
          src="../../../images/ww/monsters/310000380.webp"
          alt="Voltscourge Stalker"
        />
      )}
      {id === '310000390' && (
        <StaticImage
          src="../../../images/ww/monsters/310000390.webp"
          alt="Frostscourge Stalker"
        />
      )}
      {id === '310000400' && (
        <StaticImage
          src="../../../images/ww/monsters/310000400.webp"
          alt="Chop Chop: Headless"
        />
      )}
      {id === '310000410' && (
        <StaticImage
          src="../../../images/ww/monsters/310000410.webp"
          alt="Chop Chop: Leftless"
        />
      )}
      {id === '310000420' && (
        <StaticImage
          src="../../../images/ww/monsters/310000420.webp"
          alt="Chop Chop: Rightless"
        />
      )}
      {id === '310000430' && (
        <StaticImage
          src="../../../images/ww/monsters/310000430.webp"
          alt="Fae Ignis"
        />
      )}
      {id === '310000440' && (
        <StaticImage
          src="../../../images/ww/monsters/310000440.webp"
          alt="Nimbus Wraith"
        />
      )}
      {id === '310000450' && (
        <StaticImage
          src="../../../images/ww/monsters/310000450.webp"
          alt="Hocus Pocus"
        />
      )}
      {id === '310000460' && (
        <StaticImage
          src="../../../images/ww/monsters/310000460.webp"
          alt="Lottie Lost"
        />
      )}
      {id === '310000470' && (
        <StaticImage
          src="../../../images/ww/monsters/310000470.webp"
          alt="Diggy Duggy"
        />
      )}
      {id === '310000480' && (
        <StaticImage
          src="../../../images/ww/monsters/310000480.webp"
          alt="Chest Mimic"
        />
      )}
      {id === '320000220' && (
        <StaticImage
          src="../../../images/ww/monsters/320000220.webp"
          alt="Questless Knight"
        />
      )}
      {id === '320000230' && (
        <StaticImage
          src="../../../images/ww/monsters/320000230.webp"
          alt="Diurnus Knight"
        />
      )}
      {id === '320000240' && (
        <StaticImage
          src="../../../images/ww/monsters/320000240.webp"
          alt="Nocturnus Knight"
        />
      )}
      {id === '320000250' && (
        <StaticImage
          src="../../../images/ww/monsters/320000250.webp"
          alt="Abyssal Patricius"
        />
      )}
      {id === '320000260' && (
        <StaticImage
          src="../../../images/ww/monsters/320000260.webp"
          alt="Abyssal Gladius"
        />
      )}
      {id === '320000270' && (
        <StaticImage
          src="../../../images/ww/monsters/320000270.webp"
          alt="Abyssal Mercator"
        />
      )}
      {id === '320000280' && (
        <StaticImage
          src="../../../images/ww/monsters/320000280.webp"
          alt="Chop Chop"
        />
      )}
      {id === '320000290' && (
        <StaticImage
          src="../../../images/ww/monsters/320000290.webp"
          alt="Vitreum Dancer"
        />
      )}
      {id === '320000300' && (
        <StaticImage
          src="../../../images/ww/monsters/320000300.webp"
          alt="Cuddle Wuddle"
        />
      )}
      {id === '330000110' && (
        <StaticImage
          src="../../../images/ww/monsters/330000110.webp"
          alt="Lorelei"
        />
      )}
      {id === '330000120' && (
        <StaticImage
          src="../../../images/ww/monsters/330000120.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '330000130' && (
        <StaticImage
          src="../../../images/ww/monsters/330000130.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '330000140' && (
        <StaticImage
          src="../../../images/ww/monsters/330000140.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '330000150' && (
        <StaticImage
          src="../../../images/ww/monsters/330000150.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '330000160' && (
        <StaticImage
          src="../../../images/ww/monsters/330000160.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '330000170' && (
        <StaticImage
          src="../../../images/ww/monsters/330000170.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '330000180' && (
        <StaticImage
          src="../../../images/ww/monsters/330000180.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '330000190' && (
        <StaticImage
          src="../../../images/ww/monsters/330000190.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '330000200' && (
        <StaticImage
          src="../../../images/ww/monsters/330000200.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '340000100' && (
        <StaticImage
          src="../../../images/ww/monsters/340000100.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '350000140' && (
        <StaticImage
          src="../../../images/ww/monsters/350000140.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '350000150' && (
        <StaticImage
          src="../../../images/ww/monsters/350000150.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '350000160' && (
        <StaticImage
          src="../../../images/ww/monsters/350000160.webp"
          alt="Sentry Construct"
        />
      )}
      {id === '6000051' && (
        <StaticImage
          src="../../../images/ww/monsters/6000051.webp"
          alt="Echo Image"
        />
      )}
      {id === '6000054' && (
        <StaticImage
          src="../../../images/ww/monsters/6000054.webp"
          alt="Echo Image"
        />
      )}
      {id === '6000055' && (
        <StaticImage
          src="../../../images/ww/monsters/6000055.webp"
          alt="Echo Image"
        />
      )}
      {id === '6000060' && (
        <StaticImage
          src="../../../images/ww/monsters/6000060.webp"
          alt="Echo Image"
        />
      )}
      {id === '6000056' && (
        <StaticImage
          src="../../../images/ww/monsters/6000056.webp"
          alt="Echo Image"
        />
      )}
      {id === '6000057' && (
        <StaticImage
          src="../../../images/ww/monsters/6000057.webp"
          alt="Echo Image"
        />
      )}
      {id === '6000058' && (
        <StaticImage
          src="../../../images/ww/monsters/6000058.webp"
          alt="Echo Image"
        />
      )}
      {id === '6000059' && (
        <StaticImage
          src="../../../images/ww/monsters/6000059.webp"
          alt="Echo Image"
        />
      )}
      {id === '340000020' && (
        <StaticImage
          src="../../../images/ww/monsters/340000020.webp"
          alt="Echo Image"
        />
      )}
      {id === '340000070' && (
        <StaticImage
          src="../../../images/ww/monsters/340000070.webp"
          alt="Echo Image"
        />
      )}
      {id === '330000010' && (
        <StaticImage
          src="../../../images/ww/monsters/330000010.webp"
          alt="Echo Image"
        />
      )}
      {id === '330000020' && (
        <StaticImage
          src="../../../images/ww/monsters/330000020.webp"
          alt="Echo Image"
        />
      )}
      {id === '330000030' && (
        <StaticImage
          src="../../../images/ww/monsters/330000030.webp"
          alt="Echo Image"
        />
      )}
      {id === '330000040' && (
        <StaticImage
          src="../../../images/ww/monsters/330000040.webp"
          alt="Echo Image"
        />
      )}
      {id === '330000050' && (
        <StaticImage
          src="../../../images/ww/monsters/330000050.webp"
          alt="Echo Image"
        />
      )}
      {id === '330000060' && (
        <StaticImage
          src="../../../images/ww/monsters/330000060.webp"
          alt="Echo Image"
        />
      )}
      {id === '340000010' && (
        <StaticImage
          src="../../../images/ww/monsters/340000010.webp"
          alt="Echo Image"
        />
      )}
      {id === '340000060' && (
        <StaticImage
          src="../../../images/ww/monsters/340000060.webp"
          alt="Echo Image"
        />
      )}
      {id === '340000080' && (
        <StaticImage
          src="../../../images/ww/monsters/340000080.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000010' && (
        <StaticImage
          src="../../../images/ww/monsters/320000010.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000020' && (
        <StaticImage
          src="../../../images/ww/monsters/320000020.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000030' && (
        <StaticImage
          src="../../../images/ww/monsters/320000030.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000040' && (
        <StaticImage
          src="../../../images/ww/monsters/320000040.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000050' && (
        <StaticImage
          src="../../../images/ww/monsters/320000050.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000060' && (
        <StaticImage
          src="../../../images/ww/monsters/320000060.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000070' && (
        <StaticImage
          src="../../../images/ww/monsters/320000070.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000080' && (
        <StaticImage
          src="../../../images/ww/monsters/320000080.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000090' && (
        <StaticImage
          src="../../../images/ww/monsters/320000090.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000100' && (
        <StaticImage
          src="../../../images/ww/monsters/320000100.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000110' && (
        <StaticImage
          src="../../../images/ww/monsters/320000110.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000120' && (
        <StaticImage
          src="../../../images/ww/monsters/320000120.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000130' && (
        <StaticImage
          src="../../../images/ww/monsters/320000130.webp"
          alt="Echo Image"
        />
      )}
      {id === '320000180' && (
        <StaticImage
          src="../../../images/ww/monsters/320000180.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000010' && (
        <StaticImage
          src="../../../images/ww/monsters/310000010.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000020' && (
        <StaticImage
          src="../../../images/ww/monsters/310000020.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000030' && (
        <StaticImage
          src="../../../images/ww/monsters/310000030.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000040' && (
        <StaticImage
          src="../../../images/ww/monsters/310000040.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000050' && (
        <StaticImage
          src="../../../images/ww/monsters/310000050.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000060' && (
        <StaticImage
          src="../../../images/ww/monsters/310000060.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000070' && (
        <StaticImage
          src="../../../images/ww/monsters/310000070.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000080' && (
        <StaticImage
          src="../../../images/ww/monsters/310000080.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000090' && (
        <StaticImage
          src="../../../images/ww/monsters/310000090.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000100' && (
        <StaticImage
          src="../../../images/ww/monsters/310000100.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000110' && (
        <StaticImage
          src="../../../images/ww/monsters/310000110.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000120' && (
        <StaticImage
          src="../../../images/ww/monsters/310000120.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000130' && (
        <StaticImage
          src="../../../images/ww/monsters/310000130.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000140' && (
        <StaticImage
          src="../../../images/ww/monsters/310000140.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000150' && (
        <StaticImage
          src="../../../images/ww/monsters/310000150.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000160' && (
        <StaticImage
          src="../../../images/ww/monsters/310000160.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000170' && (
        <StaticImage
          src="../../../images/ww/monsters/310000170.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000180' && (
        <StaticImage
          src="../../../images/ww/monsters/310000180.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000190' && (
        <StaticImage
          src="../../../images/ww/monsters/310000190.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000200' && (
        <StaticImage
          src="../../../images/ww/monsters/310000200.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000210' && (
        <StaticImage
          src="../../../images/ww/monsters/310000210.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000220' && (
        <StaticImage
          src="../../../images/ww/monsters/310000220.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000250' && (
        <StaticImage
          src="../../../images/ww/monsters/310000250.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000260' && (
        <StaticImage
          src="../../../images/ww/monsters/310000260.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000270' && (
        <StaticImage
          src="../../../images/ww/monsters/310000270.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000280' && (
        <StaticImage
          src="../../../images/ww/monsters/310000280.webp"
          alt="Echo Image"
        />
      )}
      {id === '310000330' && (
        <StaticImage
          src="../../../images/ww/monsters/310000330.webp"
          alt="Echo Image"
        />
      )}
    </>
  );
};
